import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import HeaderDataCell from './HeaderDataCell';
import Row from './server/elements/Row';
import { useColumns } from './utils/TableStore';
function HeaderRow() {
  const $ = _c(4);
  const columns = useColumns();
  let t0;
  if ($[0] !== columns) {
    t0 = columns.map(_temp);
    $[0] = columns;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Row>{t0}</Row>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(column, i) {
  return <HeaderDataCell key={column} field={column} firstRow={true} colIndex={i} />;
}
export default memo(HeaderRow);